import { render, staticRenderFns } from "./PersonDataCard.vue?vue&type=template&id=239d6676&scoped=true&"
import script from "./PersonDataCard.vue?vue&type=script&lang=js&"
export * from "./PersonDataCard.vue?vue&type=script&lang=js&"
import style0 from "./PersonDataCard.vue?vue&type=style&index=0&id=239d6676&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239d6676",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
